import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { AuthService } from './../../shared/services/auth/auth.service';
import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TabStripComponent, SelectEvent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-adjustment-reports-v2',
  templateUrl: './adjustment-reports-v2.component.html',
  styleUrls: ['./adjustment-reports-v2.component.css']
})
export class AdjustmentReportsV2Component implements OnInit, AfterViewChecked {
  operators: any;
  initialLoading = false;
  ownersList: any;
  editAdjustmentData: any;
  isRecordSaved: boolean;
  @ViewChild('adjtabstrip') tabstrip: TabStripComponent;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private notificationService: DisplayNotificationService,
  ) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.operators = this.authService.getAccessOperations(2);
    this.getAdjOwnerList();
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  adjustmentDataSaved(event: boolean) {
    this.isRecordSaved = event;
  }

  onSelect(e: SelectEvent): void {
    if (this.isRecordSaved) {
      this.getViewReport(null);
    }
    this.isRecordSaved = false;
  }


  getViewReport(event: any) {
    this.tabstrip.tabs.forEach(x => {
      switch (x.title) {
        case 'Create New Report':
          x.selected = true;
          this.editAdjustmentData = event;
          break;
        case 'View Reports':
          x.selected = false;
          break;
        case 'Rejected Reports':
          x.selected = false;
          break;
      }
    });
  }

  getAdjOwnerList() {
    const userData = { userInfo: this.usersService.UserInfo() };
    this.adjustmentService.getOwnerList(userData).subscribe((data: any) => {
      if (data && data.statusCode === 200) {
        this.ownersList = data.userList;
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

}
